/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */

import { useSyncExternalStore } from 'react';

import { getDocument } from '@atlaskit/browser-apis';

const subscribeToMediaQuery = (query: string, onStoreChange: () => void) => {
	const win = getDocument()?.defaultView;
	if (!win?.matchMedia) return () => {};
	const media = win.matchMedia(query);
	media.addEventListener('change', onStoreChange);
	return () => media.removeEventListener('change', onStoreChange);
};

const getMediaQuerySnapshot = (query: string) => {
	const win = getDocument()?.defaultView;
	if (!win?.matchMedia) return false;
	return win.matchMedia(query).matches;
};

/**
 * SSR-safe media-query hook. `useSyncExternalStore` keeps the value stable
 * during concurrent renders while still returning false on the server.
 */
export const useMediaQuery = (query: string): boolean => {
	return useSyncExternalStore(
		(onStoreChange) => subscribeToMediaQuery(query, onStoreChange),
		() => getMediaQuerySnapshot(query),
		() => false,
	);
};
